<template>
  <div class="players">
    <div class="confirmed">
      <p class="title">Confirmed entries</p>
      <div class="list" v-if="matchDetail.part">
        <div class="item" v-for="(item,index) in matchDetail.part" :key="index">
          <img :src="item.memberPhoto || item.teamAvatar" alt="">
          <p>{{item.nickName || item.name}}</p>
        </div>
      </div>
    </div>
<!--    <div class="unconfirmed">-->
<!--      <p class="title">Confirmed entries</p>-->
<!--      <div class="list">-->
<!--        <div class="item">-->
<!--          <div>-->
<!--            <img src="" alt="">-->
<!--            <p>Random user 1</p>-->
<!--          </div>-->
<!--          <p>...</p>-->
<!--        </div>-->
<!--        <div class="item">-->
<!--          <div>-->
<!--            <img src="" alt="">-->
<!--            <p>Random user 1</p>-->
<!--          </div>-->
<!--          <p>...</p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import {inject} from "vue";

export default {
  name: "players-content",
  setup() {
    const matchDetail = inject('matchDetail')
    return {
      matchDetail,
    }
  }
}
</script>

<style scoped lang="scss">
.players {
  padding-top: 50PX;

  .title {
    font-size: 30PX;
    color: #ffffff;
    padding-bottom: 40PX;
  }

  .confirmed {
    padding-bottom: 118PX;
  }
  .unconfirmed {
    padding-bottom: 70PX;
  }

  .list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .item {
      padding: 10PX;
      font-size: 24PX;
      color: #ffffff;
      width: 130PX;
      text-align: center;

      img {
        display: block;
        width: 78PX;
        height: 78PX;
        border-radius: 50%;
        background: #9BA1B1;
        margin: 0 auto 6px;
      }

      p{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

}
</style>
